.root {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heading {
  margin: 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
  // Deliberately UNCAPPED: the thread renders in full and the surrounding
  // surface (drawer body / expanded row) does the scrolling, with its
  // scrollbar hidden there.
}

.item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: var(--drawer-card-radius, 8px);
  background: var(--color-muted-background, #f9fafb);
}

.item-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.body {
  /* A comment keeps the author's line breaks and never overflows the card. */
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.state {
  display: flex;
  align-items: center;
  gap: 8px;
}

.composer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.composer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
